/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Permissions_Seeless2Inputs */

const en_usermanagement_permissions_seeless2 = /** @type {(inputs: Usermanagement_Permissions_Seeless2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See less permissions`)
};

/**
* | output |
* | --- |
* | "See less permissions" |
*
* @param {Usermanagement_Permissions_Seeless2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_permissions_seeless2 = /** @type {((inputs?: Usermanagement_Permissions_Seeless2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Permissions_Seeless2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_permissions_seeless2(inputs)
});
export { usermanagement_permissions_seeless2 as "userManagement_permissions_seeLess" }